import React, { Dropdown as AntdDropdown, type DropdownProps, type MenuProps } from 'antd';
import { FC } from 'react';
import './Dropdown.scss';
import { twMerge } from '@shared/utils/twMerge';

export type MenuItemType = NonNullable<MenuProps['items']>[number];

export type CustomDropdownProps = DropdownProps & {
  items?: MenuItemType[];
  onClick?: MenuProps['onClick'];
  menuClassName?: string;
};

export const Dropdown: FC<CustomDropdownProps> = ({
  items,
  overlayClassName,
  placement = 'bottomLeft',
  children = <></>,
  onClick,
  menuClassName,
  ...otherProps
}) => {
  return (
    <AntdDropdown
      {...otherProps}
      menu={{ items, onClick, className: menuClassName ?? '' }}
      placement={placement}
      overlayClassName={twMerge('antd-custom-dropdown', overlayClassName)}
    >
      {children}
    </AntdDropdown>
  );
};
